import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { coerceNumber } from '@partners/utils';
import { INumericValidationHandler, TValidatorError } from '../../model';

export function multiplierValidator(args: INumericValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const numericValue = coerceNumber(value);
    const numericMultiplier = coerceNumber(args?.multiplier);
    const isValidArgs = numericMultiplier && numericMultiplier != 0 && numericMultiplier && numericMultiplier !== 0;

    let matchMultiplier = isValidArgs && numericValue % numericMultiplier === 0;

    if (!matchMultiplier) {
      const vldResponse: TValidatorError = { multiplier: args?.multiplier };
      return vldResponse;
    }

    return null;
  };
}
